import React, { Component, createRef } from "react";
import moment from "moment";
import { EmprestimoService } from "../../../services";
import { MasterPage, NumFuncionalidade } from "../../MasterPage";
import { Alerta, Botao, Box, CampoEstatico, Combo, TipoAlerta, TipoBotao, TipoCampoEstatico } from "@intechprev/componentes-web";
import { RelIRRFEntidade } from "../../../entidades";

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

interface IProps { }

interface State {
  Error: string;
  Referencia: string;
  Datas: any[];
  Dados: RelIRRFEntidade;
}

export class EmprestimosInforme extends Component<IProps, State> {
  private page = createRef<MasterPage>();

  constructor(props: IProps) {
    super(props);

    this.state = {
      Error: "",
      Referencia: "",
      Datas: [],
      Dados: null
    }
  }

  componentDidMount = async () => {
    await this.page.current.alternarLoading();
    try {
      const datas = await EmprestimoService.BuscarListaAnoCalendarioInforme();
      this.setState({
        Referencia: datas[0],
        Datas: datas
      }, this.handleReferenciaChange);
    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ Error });
    }
    finally {
      await this.page.current.alternarLoading();
    }
  }

  handleReferenciaChange = async () => {
    this.setState({ Error: "" });
    try {
      const Referencia = this.state.Referencia;
      if (this.state.Datas.length > 0 && Referencia) {
        var data = this.state.Datas.filter((x) => x === Referencia)[0];
        let dados = await EmprestimoService.BuscarInformePorAno(
          moment(data, "DD/MM/yyyy").format("DD.MM.yyyy")
        );
        this.setState({
          Dados: dados,
          Referencia
        });
      }
    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ Error });
    }
  }

  gerarInforme = async () => {
    this.setState({ Error: "" });
    try {
      const Referencia = this.state.Referencia || this.state.Datas[0].toString();
      var data = this.state.Datas.filter((x) => x.toString() === Referencia)[0];
      var relatorio = await EmprestimoService.GerarInformePorAno(
        moment(data, "DD/MM/yyyy").format("DD.MM.yyyy"), false
      );

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "Informe de Rendimentos.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Informe de Rendimentos.pdf");
        document.body.appendChild(link);
        link.click();
      }
    } catch (err) {
      const e: any = err;
      const Error = e.response ? e.response.data : e;
      console.log(Error);
      this.setState({ Error });
    }
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.DEMONSTRATIVO_EMPRESTIMO} {...this.props} ref={this.page}>
        <Box titulo={"Resumo"}>
          {this.state.Datas.length > 0 && (
            <>
              <Combo
                contexto={this}
                nome={"Referencia"}
                titulo={"Referência"}
                onChange={this.handleReferenciaChange}
                valor={this.state.Referencia}
                opcoes={this.state.Datas}
                tamanhoTitulo={"3"}
              />

              {this.state.Dados && this.state.Error === "" && (
                <>
                  <CampoEstatico
                    valor={this.state.Dados.CONTRATOS}
                    titulo={"Contratos"}
                  />

                  <CampoEstatico
                    titulo={`Saldo Atual (${this.state.Dados.DT_REF})`}
                    valor={this.state.Dados.VL_SALDO_ANO_REF}
                    tipo={TipoCampoEstatico.dinheiro}
                  />

                  <CampoEstatico
                    titulo={`Saldo Anterior (${this.state.Dados.DT_REF_ANT})`}
                    valor={this.state.Dados.VL_SALDO_ANO_ANT}
                    tipo={TipoCampoEstatico.dinheiro}
                  />

                  <CampoEstatico
                    titulo={"Valor Pago no Ano"}
                    valor={this.state.Dados.VL_PRESTACAO}
                    tipo={TipoCampoEstatico.dinheiro}
                  />

                  <CampoEstatico
                    titulo={"Juros / Correção Monetária"}
                    valor={this.state.Dados.VL_JUROS_CALCULADO}
                    tipo={TipoCampoEstatico.dinheiro}
                  />

                  <CampoEstatico
                    titulo={"Amortização"}
                    valor={this.state.Dados.VL_AMORTIZACAO_CALCULADO}
                    tipo={TipoCampoEstatico.dinheiro}
                  />

                  <Botao
                    tipo={TipoBotao.primary}
                    titulo={"Gerar Informe para Fins de IR"}
                    onClick={this.gerarInforme}
                    className={"mb-2 ml-2"}
                    usaLoading
                  />
                </>
              )}

              <Alerta
                tipo={TipoAlerta.danger}
                mensagem={this.state.Error}
              />
            </>
          )}

          {this.state.Datas.length === 0 && (
            <Alerta
              tipo={TipoAlerta.info}
              mensagem={"Não foram encontrados nenhum informe."}
            />
          )}
        </Box>
      </MasterPage>
    );
  }
};
